// Типы для уведомлений (приводим к форме, ожидаемой компонентами)
export interface NotificationItem {
    id: number;
    text: string;
    time: string; // ISO
    status: number; // 0 = unread, 1 = read
}

export interface NotificationFilters {
    page?: number;
    limit?: number; // компоненты используют 'limit'
}

export const notificationEndpoints = {
    getNotifications: {
        query: (filters?: NotificationFilters) => ({
            url: "/notifications",
            params: filters,
        }),
        providesTags: () => [{ type: "Notifications" as const, id: "LIST" }],
        // Нормализуем ответ к { data: NotificationItem[], pagination?: {...} }
        transformResponse: (response: any) => {
            const itemsRaw = response?.data ?? response ?? [];
            const data: NotificationItem[] = (itemsRaw || []).map((n: any) => ({
                id: Number(n.id ?? n.notification_id ?? 0),
                text: String(n.text ?? n.message ?? ""),
                time: String(
                    n.time ?? n.created_at ?? new Date().toISOString()
                ),
                status: Number(
                    typeof n.status !== "undefined"
                        ? n.status
                        : n.is_read
                        ? 1
                        : 0
                ),
            }));
            const pagination =
                response?.pagination || response?.meta || undefined;
            return { data, pagination };
        },
    },

    markAsRead: {
        query: (id: number) => ({
            url: `/notifications/${id}/read`,
            method: "PATCH",
        }),
        invalidatesTags: () => [
            { type: "Notifications" as const, id: "LIST" },
            { type: "UnreadCount" as const, id: "COUNT" },
        ],
    },

    markAllAsRead: {
        query: () => ({
            url: "/notifications/mark-all-read",
            method: "PATCH",
        }),
        invalidatesTags: () => [
            { type: "Notifications" as const, id: "LIST" },
            { type: "UnreadCount" as const, id: "COUNT" },
        ],
    },

    getUnreadCount: {
        query: () => "/notifications/unread-count",
        providesTags: () => [{ type: "UnreadCount" as const, id: "COUNT" }],
    },

    deleteNotification: {
        query: (id: number) => ({
            url: `/notifications/${id}`,
            method: "DELETE",
        }),
        invalidatesTags: () => [
            { type: "Notifications" as const, id: "LIST" },
            { type: "UnreadCount" as const, id: "COUNT" },
        ],
    },
};

export const notificationTags = ["Notifications", "UnreadCount"] as const;
